// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"303":"7a7ab2ed","447":"7fcc09e8"}[chunkId] + ".chunk.css";
};